<template>
  <div class="competency-info ccs-fields">
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Код Компетенции
      </div>
      <div class="field-value">
        {{ skill.code }}
      </div>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Наименование компетенции (Рус)
      </div>
      <div class="field-value">
        {{ skill.name_rus }}
      </div>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Наименование компетенции (En)
      </div>
      <div class="field-value">
        {{ skill.name_eng }}
      </div>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Статус на мероприятии
      </div>
      <div class="field-value">
        {{ skill.status }}
      </div>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Статус готовности к мероприятию
      </div>
      <div class="field-value">
        Заполнение ИЛ
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Info',
  computed: {
    ...mapState('skills', ['skill']),
  },
};
</script>

<style lang="scss" scoped>
.competency-info {
  min-height: 100%;
  min-width: 100%;
  background: #fff;

  .info-button {
    padding-left: 0;
  }

}
</style>
